import React, { useEffect, useRef } from 'react';
import renderMathInElement from 'katex/dist/contrib/auto-render.min.js';
import 'katex/dist/katex.min.css';

type Props = {
  text: string;
};

const LatexContainer = ({ text }: Props) => {
  const katexTextRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (katexTextRef.current) {
      renderMathInElement(katexTextRef.current, {});
    }
  }, [katexTextRef.current, text]);
  return <div ref={katexTextRef}>{text}</div>;
};

export default LatexContainer;
